"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preconditions_ts_1 = require("preconditions-ts");
var React = require("react");
var definitions_1 = require("./definitions");
exports.Icon = React.memo(function (props) {
    var icon = props.icon, color = props.color, onClick = props.onClick, className = props.className;
    var definition = definitions_1.iconDefinitions.get(icon);
    if (!definition) {
        return React.createElement("svg", null);
    }
    var size = Math.max(definition.width, definition.height);
    var x = (size - definition.width) * 0.5;
    var y = (size - definition.height) * 0.5;
    var iconRect = {
        x: x,
        y: y,
        width: definition.width,
        height: definition.height,
    };
    var paths = definition.paths.map(function (path, index) { return (React.createElement("path", { key: "icon-" + icon + "-path" + index, pointerEvents: 'none', d: path })); });
    return (React.createElement("svg", { viewBox: "0 0 " + size + " " + size, x: '0px', y: '0px', className: className, style: {
            fill: color ? color.hex() : 'currentColor',
            cursor: onClick !== undefined ? 'pointer' : 'default',
        } },
        React.createElement("rect", { x: 0, y: 0, width: size, height: size, pointerEvents: 'all', fill: 'none', onClick: onClick }),
        React.createElement("g", { transform: exports.createIconTransform(icon, iconRect) }, paths)));
});
exports.getIconDefinition = function (icon) {
    return preconditions_ts_1.required(definitions_1.iconDefinitions.get(icon), "unable to find " + icon + " icon");
};
exports.getIconPaths = function (icon) {
    return preconditions_ts_1.required(definitions_1.iconDefinitions.get(icon)).paths;
};
exports.createIconTransform = function (icon, rect) {
    var definition = preconditions_ts_1.required(definitions_1.iconDefinitions.get(icon));
    var scaleX = rect.width / definition.width;
    var scaleY = rect.height / definition.height;
    return "translate(" + rect.x + ", " + rect.y + ") scale(" + scaleX + ", " + scaleY + ")";
};
exports.Icon.displayName = 'Icon';
